import React from 'react';
import { Query } from '@cubejs-client/core';

import useCubeReportQuery from 'Hooks/query-hooks/reports/useCubeReportQuery';
import AcceptRejectChartDashlet from '../AcceptRejectChartDashlet';
import { generateChartData } from '../helpers';
import styles from './TransactionValueDashlet.css';

type Props = {
    formValues?: ProcessedNewMerchantReportFormValues;
    focusView: string;
};

const TransactionValueDashlet = ({ formValues, focusView }: Props) => {
    const { resultSet, isLoading } = useCubeReportQuery(
        formValues,
        formValues?.fullQueries?.transactionValueQuery as Query
    );

    const pivotData = resultSet?.chartPivot()[0];
    const { newSeriesData, percentageValue } = generateChartData(pivotData, focusView, 'value');

    return (
        <AcceptRejectChartDashlet
            focusView={focusView}
            className={styles.container}
            seriesData={newSeriesData}
            isLoading={isLoading}
            header='Transaction Value'
            totalLabel='Total Value'
            percentageValue={percentageValue}
            singleMerchantId={formValues?.singleMerchantId}
            dataTestId='transaction-value-chart'
            isCurrency
        />
    );
};

export default TransactionValueDashlet;
